import { render, staticRenderFns } from "./nftCard.vue?vue&type=template&id=1cb1750a&scoped=true"
import script from "./nftCard.vue?vue&type=script&lang=js"
export * from "./nftCard.vue?vue&type=script&lang=js"
import style0 from "./nftCard.vue?vue&type=style&index=0&id=1cb1750a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb1750a",
  null
  
)

export default component.exports